import React, { FC, FormEvent, useState } from "react";
import {
  ActionTypeEnum,
  EmployeeListItemModel,
  HasFormIdModel,
} from "../../models";
import { getLabelName, isArabicCurrentLanguage } from "../../utils";
import { ButtonBox, PrivilegesChecker, TextBox, GridTable } from "..";

interface EmployeeList extends HasFormIdModel {
  request: EmployeeListItemModel[];
  isModifyAble?: boolean | null;
  isDeleteAble?: boolean | null;
  isPermissionAble?: boolean | null;
  onActionEvent?: any | null;
  onCompleteEvent?: any | null;
}

export const EmployeeList: FC<EmployeeList> = ({
  request,
  onActionEvent,
  formId,
}) => {
  //#region state
  const isArabic = isArabicCurrentLanguage();

  const [searchedWord, setSearchedWord] = useState("");
  //#endregion
  //#region function
  const handleSearchEmployeeByName = () => {
    onActionEvent({ action: ActionTypeEnum.Search, request: searchedWord });
  };
  //#endregion
  //#region html
  return (
    <>
      <PrivilegesChecker formId={formId} action="EnableSearch">
        <div
          className="d-flex gap-2 mb-4 justify-content-between align-items-center"
          style={{ maxWidth: "100%", width: "100%" }}
        >
          <div style={{ flex: "1 1 auto", minWidth: "160px" }}>
            <TextBox
              inputName="search"
              inputValue={searchedWord}
              onChange={(e: FormEvent<HTMLInputElement>) =>
                setSearchedWord(e.currentTarget.value)
              }
              labelName=""
              placeHolder={`${getLabelName("name")}, ${getLabelName("phone")}`}
              controlSize="w-100"
            />
          </div>
          <ButtonBox onClick={handleSearchEmployeeByName}>
            {getLabelName("search")}
          </ButtonBox>
        </div>
      </PrivilegesChecker>
      {request != null && request.length !== 0 && (
        <GridTable
          currentPage={1}
          totalRows={request.filter(({ shown }) => shown).length}
          pageSize={10}
          // columns={setEmployeeColumns({ onActionEvent }, formId)}
          columnsProps={{
            actions: [
              ActionTypeEnum.Update,
              ActionTypeEnum.ShowCommission,
              ActionTypeEnum.Delete,
            ],
            isArabic,
            onActionEvent,
          }}
          data={request.filter(({ shown }) => shown)}
          paginationType={"client"}
          formId={formId}
        />
      )}
    </>
  );
  //#endregion
};
